import { Component } from '@angular/core';

@Component({
  selector: 'quotely-not-found',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
}
